import React, { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import EnvelopeIconSvg from 'assets/svgs/contact-us/EnvelopeIconSvg.svg';
import LocationIconSvg from 'assets/svgs/contact-us/LocationIconSvg.svg';
import PhoneIconSvg from 'assets/svgs/contact-us/PhoneIconSvg.svg';

export const EnvelopeIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <EnvelopeIconSvg ref={ref} {...props} />
));

export const LocationIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <LocationIconSvg ref={ref} {...props} />
));

export const PhoneIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <PhoneIconSvg ref={ref} {...props} />
));
